import React from "react";
import { Paper, Table, TableBody, TableContainer } from "@mui/material";
import { useNavigate } from "react-router-dom";
import UserListItem from "./UserListItem";
import { IUser } from "./types";
import FloatingActionButton from "../../Components/FloatingActionButton";

interface IUserListProps {
  users: IUser[];
}

const UserList = (props: IUserListProps) => {
  const { users } = props;
  const navigate = useNavigate();
  const handleAddUser = () => navigate("/users/-1");
  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small" data-cy="users">
          <TableBody>
            {users.map((user) => (
              <UserListItem key={user.id} user={user} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <FloatingActionButton
        iconName="account-plus"
        onClick={handleAddUser}
        data-cy="user-add"
      />
    </>
  );
};

export default UserList;
